import React, { useState } from 'react';
import { get } from 'lodash';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { Grid, ButtonBase } from '@material-ui/core';
import { ReactSVG } from 'react-svg';
import Text from '../../../../components/typography';
import NewDropdown from '../../../../components/ui/NewDropdown';
import { theme } from '../../../../themes/default-theme';
import NewLinks from '../../../../components/ui/NewLinks';
import close from '../../../../assets/icons/new-close.svg';
import { RespImg } from '../../../../components/ui';

const Container = styled.div`
  border-bottom: 1px solid ${theme.palette.middleGrey};
  ${theme.breakpoints.up('md')} {
    margin: 25px 0 25px;

  }
  ${theme.breakpoints.down('sm')} {
    margin: 15px 0 15px;

  }
`

const FormItem = styled.div`
  display: block;
  margin:${props => props.margin === 'none' ? `0` : `0 0 15px`};
  text-align: left;

  ${theme.breakpoints.up('md')} {
    margin:${props => props.margin === 'none' ? `0` : `0 0 25px 0`};
  }

  h6 {
    font-weight: 800;
    margin-bottom: 15px;
    letter-spacing: normal;
    ${theme.breakpoints.up('md')} {
      font-size: 18px;
      line-height: 24px;
    }
    ${theme.breakpoints.down('sm')} {
      font-size: 15px;
      line-height: 24px;
    }
  }
`
const FormCol = styled.div`
  position: relative;
  
  ${theme.breakpoints.down('sm')} {
    ${props => props.position === 'left' && `
      margin-bottom: 30px;
    }`
  }

  ${theme.breakpoints.up('md')} {
    ${props => props.position === 'left' ? `
      padding-right: 15px;
    ` : `
      padding-left: 15px;
    `}
  }
`

const Add = styled.div`
  cursor: pointer;
  ${props => props.margin === 1 && `
    margin-top: 25px;
  `}
  
  a span {
    display: inline-block;
    vertical-align: middle;
  }

  button {
    margin-right: 10px;
    &:hover {
      background-color: ${theme.palette.vividBlue};
    }
  }
`

const Remove = styled.div`
  margin: 30px 0 0;
  padding: 0 0 30px;
  ${props => props.borderBottom !== false && `
    border-bottom: 1px solid ${theme.palette.middleGrey};
  `}
  svg {
    [stroke] {
      stroke: white;
    }
  }
`

const ModelImg = styled.div`
  picture,
  img {
    width: 100%;
    height: auto;
    display: block;
    max-width: 300px;
    margin: 0 auto;
  }
`

const Close = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;

  button {
    padding: 5px;
  }

  svg {
    display: block;
    width: 16px;
    height: 16px;
    [stroke] {
      stroke: #7D7D7D;
    }
  }
`

const ModelOfInterestTitle = styled.div`
    margin-top: 55px;
    border-bottom: 1px solid ${theme.palette.middleGrey};
    h2 {
      color: #2E3238;
      font-weight: 800;
      letter-spacing: normal;
    }
    ${theme.breakpoints.up('md')} {
        padding-bottom: 25px;
        h2 {
          font-size: 20px;
          line-height: 24px;
        }
    }
    ${theme.breakpoints.down('sm')} {
      padding-bottom: 15px;
      h2 {
        font-size: 14px;
        line-height: 24px;
      }
    }
`

const ModelOfInterest = ({ formProps, error, onFormChange, state, ranges, modelsOfInterest, onChange, onAddModel, onRemoveModel, showModelDropdown, title }) => {

  const {
    control,
    errors
  } = formProps

  return (
    <>
      {ranges && ranges.length > 0 &&
        title &&
        <ModelOfInterestTitle>
          <Text variant="h2" uppercase align="center">{title}</Text>
        </ModelOfInterestTitle>
      }
      {modelsOfInterest && modelsOfInterest.length > 0 && modelsOfInterest.map((item, index) => {

        const itemRanges = ranges.find(range => range.id === item.rangeId);
        const itemSeries = get(itemRanges, 'models', []).find(series => series.seriesTitle === item.seriesTitle);

        const models = itemSeries && itemSeries.models ? itemSeries.models : [{ ...itemSeries }] // (dealer stock)

        const dropdownValues = models ? models.map((item, i) => {
          return {
            id: item.id,
            value: item.title ? item.title : item.size,
            text: item.title ? item.title : item.size,
          }
        }).filter(i => {
          // return false if value.id is already in modelsOfInterest
          return ((!modelsOfInterest.find(j => j.id === i.id) || i.id === item.id)) ? true : false
        }) : []


        let rangeTitle = item.rangeTitle ? item.rangeTitle.toLowerCase() : '';

       
        rangeTitle = rangeTitle.endsWith('s') ? rangeTitle.slice(0, -1) : rangeTitle;
        const seriesRangeTitle = `${item.seriesTitle} ${rangeTitle}`
        const itemArr = seriesRangeTitle.split(' ')
        const itemTitle = (itemArr.length > 2) ? `${itemArr[0]} ${itemArr[1]}` : seriesRangeTitle

        return (
          <Container key={index + item.id}>
            <Grid container direction={'row'} justifyContent={'space-between'} align={'center'}>
              <Grid item xs={3} md={3}>
                <FormCol position="left">
                  <FormItem>
                    {item.image &&
                      <ModelImg>
                        {item.image.sizes ?
                          <RespImg
                            {...item.image}
                          />
                          :
                          <img src={item.image} alt={item.title} />
                        }
                      </ModelImg>
                    }
                  </FormItem>
                </FormCol>
              </Grid>
              <Grid item xs={9} md={9}>
                <FormCol position="right">
                  <FormItem>
                    <Close>
                      <ButtonBase onClick={() => onRemoveModel(index)}>
                        <ReactSVG src={close} />
                      </ButtonBase>
                    </Close>
                    <Text variant="h6" uppercase colour="vividBlue">{item.seriesTitle}</Text>
                    <NewDropdown
                      variant="outlined"
                      showComplete={true}
                      label={null}
                      options={dropdownValues ? dropdownValues : []}
                      disabled={models ? false : true}
                      value={item.title}
                      onChange={(e) => e && onChange(index, models.find(model => model.id === e.id))}
                    />
                  </FormItem>
                </FormCol>
              </Grid>
            </Grid>

          </Container>
        )
      })}
      {modelsOfInterest && modelsOfInterest.length < 3 &&
        <Grid container direction={'row'} justifyContent={'space-between'} align={'left'}>
          <Grid item xs={12}>
            <Add margin={modelsOfInterest.length === 0 ? 1 : 0} onClick={onAddModel}>
              <NewLinks>
                Add Model
              </NewLinks>
            </Add>
          </Grid>
        </Grid>
      }
    </>
  )
}

ModelOfInterest.propTypes = {
  onChange: propTypes.func,
  onAddModel: propTypes.func,
  onRemoveModel: propTypes.func,
  showModelDropdown: propTypes.bool
}

ModelOfInterest.defaultProps = {
  onChange: () => { },
  onAddModel: () => { },
  onRemoveModel: () => { },
  showModelDropdown: true
}

export default ModelOfInterest